import React, { useEffect, useRef, useState } from 'react'
import { PACKAGE_CARD } from '../../utils/dataTrackingValues'
import Theme from '../../utils/theme'
import DefaultPackageCard from './DefaultPackageCard'
import HorizontalPackageCard from './HorizontalPackageCard'
import * as Styled from './PackageCard.styles'

const PackageCard = ({
  children = null,
  content = null,
  image = null,
  label = '',
  layout = 'Default',
  mobileCarousel = false,
  modal = null,
  packageData,
  requestId = null,
}) => {
  const labelRef = useRef(null)
  const [height, setHeight] = useState(0)
  const labelData = {
    inside: Theme?.components?.PackageCard?.label?.inside,
    type: packageData?.labelOffer ? 'brandyLabel' : 'contentfulLabel',
    text: packageData?.labelOffer || label,
  }

  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (mounted && labelRef.current) {
      setHeight(labelRef.current.offsetHeight)
    }
  }, [mounted])

  const renderPackageCard = () => {
    if (layout === 'Horizontal') {
      return (
        <HorizontalPackageCard
          labelData={labelData}
          packageData={packageData}
          height={height}
          modal={modal}
          content={content}
          requestId={requestId}
          mobileCarousel={mobileCarousel}
          layout={layout}
          image={image}
        >
          {children}
        </HorizontalPackageCard>
      )
    }
    return (
      <DefaultPackageCard
        labelData={labelData}
        labelRef={labelRef}
        packageData={packageData}
        height={height}
        modal={modal}
        content={content}
        requestId={requestId}
        mobileCarousel={mobileCarousel}
        layout={layout}
      >
        {children}
      </DefaultPackageCard>
    )
  }

  return (
    <Styled.PackageCardWrapper
      className="leshen-package-card"
      layout={layout}
      height={height}
      labelType={labelData.type}
      extraTopSpacingForLabel={labelData?.text}
      mobileCarousel={mobileCarousel}
      onClick={() => PACKAGE_CARD.handleClick(packageData.name, requestId)}
    >
      {renderPackageCard()}
    </Styled.PackageCardWrapper>
  )
}

const PackageCardWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <PackageCard {...props} />
}

/* eslint-enable react/no-danger */
export default PackageCardWrapper
